import React from 'react';
import { useTranslation } from 'i18n';
import { withForwardRef } from 'hoc';
import DialogConfirm from 'components/dialog/dialog-click-confirm';
import { WithMargin } from 'components/layout';
import { Text } from 'components/dialog/delete-confirm/style';

import { ModalContext } from 'hoc/with-modal';

export interface DeleteConfirmModalContext extends ModalContext {
  setIsLoading: Function;
}

export interface DeleteConfirmModalProps {
  forwardedRef: any;
  data: {
    onConfirmHandler: Function;
    name: string;
  };
  ref: any;
}

const defaultProps = {};

function DeleteConfirmModal({
  forwardedRef,
  ...props
}: DeleteConfirmModalProps) {
  const { t } = useTranslation();
  const modal = React.useRef<any>(null);
  const [data, setData] = React.useState<any>({});
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useImperativeHandle(forwardedRef, () => ({
    ...(modal.current || {}),
    setData,
    setIsLoading,
  }));

  function stopLoading() {
    setIsLoading(false);
  }

  function onConfirm(event) {
    stopLoading();
    data?.onConfirmHandler(event);
  }

  return (
    <DialogConfirm
      {...props}
      ref={modal}
      isLoading={isLoading}
      onConfirm={onConfirm}
      onCancel={stopLoading}
      onHide={stopLoading}
      style={{ width: '430px' }}>
      <WithMargin top="28px" bottom="24px">
        <Text>
          {t(
            'Are you sure that you want to delete {{name}}? {{additionalText}}',
            {
              replace: {
                name: data?.name,
                additionalText: data?.additionalText ?? '',
              },
            },
          )}
        </Text>
      </WithMargin>
    </DialogConfirm>
  );
}

DeleteConfirmModal.defaultProps = defaultProps;

export default withForwardRef(DeleteConfirmModal);
